import { ControlStyleOptionIdType } from '@/pages/Onboarding/options/ControlStyle/types';
import { DominatrixVisualStyleOptionIdType } from '@/pages/Onboarding/options/DominatrixVisualStyle/types';
import { SafewordChoiceOptionIdType } from '@/pages/Onboarding/options/SafewordChoice/types';
import { ToolsOptionIdType } from '@/pages/Onboarding/options/Tools/types';
import { VoiceStyleOptionIdType } from '@/pages/Onboarding/options/VoiceStyle/types';
import { PlanFeatureType } from '@/pages/Paywall/components/ProFeatures/constant';

const controlStyleTitles: Record<ControlStyleOptionIdType, string> = {
  cold_and_cruel: '👑  Cold and cruel',
  seductive_but_strict: '❤️‍🔥 Seductive but strict',
  playful_with_a_whip: '💦 Playful with a whip',
  silent_and_merciless: '💔  Silent and merciless',
};

const dominatrixStyleTitles: Record<DominatrixVisualStyleOptionIdType, string> =
  {
    latex: '💣   Tall and commanding in latex',
    casual: '👒  Casual, but deadly',
    corset: '👠  Elegant in heels and corset',
    dress: '👗 Elegant in form-fitting dress',
  };

const voiceStyleTitles: Record<VoiceStyleOptionIdType, string> = {
  deep_hypnotic: '👄 Deep and hypnotic voice',
  cold_articulate: '👄 Cold and articulate voice',
  soft_dominant: '👄 Soft but dominant voice',
  whispering_threats: '👄  Whispering threats voice',
};

const safewordTitles: Record<SafewordChoiceOptionIdType, string> = {
  little_control: '💦  Just a little control',
  no_control: '💦  Her rules, her will',
  safeword_whisper: '💦  She doesn’t listen',
};

const toolsTitles: Record<ToolsOptionIdType, string> = {
  whip: '⚡  Using whip',
  chains: ' ⛓️Using chains',
  rope: '🪢  Using rope',
  gag: '🔴 Using gag',
  choker: '💫  Using choker with leash',
};

interface GeneratePlanParams {
  control_style: ControlStyleOptionIdType | null;
  dominatrix_visual_style: DominatrixVisualStyleOptionIdType | null;
  voice_style: VoiceStyleOptionIdType | null;
  safeword_choice: SafewordChoiceOptionIdType | null;
  tools: ToolsOptionIdType | null;
}

export function generatePlansAccess(
  params: GeneratePlanParams,
): PlanFeatureType[] {
  const plansAccess: PlanFeatureType[] = [];

  const controlStyle = params.control_style || 'cold_and_cruel';
  plansAccess.push({
    title: controlStyleTitles[controlStyle],
    free: false,
    pro: true,
  });

  const dominatrixStyle = params.dominatrix_visual_style || 'corset';
  plansAccess.push({
    title: dominatrixStyleTitles[dominatrixStyle],
    free: false,
    pro: true,
  });

  const voiceStyle = params.voice_style || 'deep_hypnotic';
  plansAccess.push({
    title: voiceStyleTitles[voiceStyle],
    free: false,
    pro: true,
  });

  const safewordChoice = params.safeword_choice || 'no_control';
  plansAccess.push({
    title: safewordTitles[safewordChoice],
    free: false,
    pro: true,
  });

  const tools = params.tools || 'chains';
  plansAccess.push({
    title: toolsTitles[tools],
    free: false,
    pro: true,
  });

  plansAccess.push({
    title: '📷 Unlimited photos and videos',
    free: false,
    pro: true,
  });

  plansAccess.push({
    title: '⚡ Fast responses',
    free: false,
    pro: true,
  });

  return plansAccess;
}
